<template>
  <div class="search-header">
    <!-- 本页搜索显示 -->
    <div
      v-if="needInputSearch"
      class="text-search-wrap"
    >
      <el-input
        v-model="searchForm.searchText"
        placeholder="请输入内容"
        @keyup.native.code.13="search"
      >
        <el-select
          slot="prepend"
          v-model="searchForm.searchType"
          class="type-select"
          placeholder="请选择"
        >
          <el-option
            v-for="(item, index) in searhTypeOptions"
            :key="index"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-button
          slot="append"
          icon="search"
          @click="search"
        />
      </el-input>
    </div>

    <ul class="filter-condition">
      <li class="filter-item">
        <label>属性</label>
        <div class="filter-item-content">
          <span
            v-for="(item, index) in atributeOptions"
            :key="index"
          >
            <el-dropdown
              v-if="item.Children && item.Children.length"
              menu-align="start"
              @command="choseAttribute"
            >
              <span class="el-dropdown-link">
                <span
                  :class="{'history-area-active-text': params.attribute === item.Name}"
                  class="pointer"
                  @click.stop="choseAttribute(item)"
                >{{ item.Name }}</span>
                <i class="pointer el-icon-arrow-down el-icon--right" />
              </span>
              <el-dropdown-menu
                slot="dropdown"
                class="history-area-dropdown-menu"
              >
                <el-dropdown-item
                  v-for="child in item.Children"
                  :key="child.Id"
                  :command="child"
                  :class="{'history-area-active-text': params.attribute === child.Name}"
                  class="history-area-blue-text"
                >{{ child.Name }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <span
              v-else
              :class="{'history-area-active-text': params.attribute === item.Name}"
              class="pointer margin-right32 history-area-attribute-item"
              @click.stop="choseAttribute(item)"
            >
              {{ item.Name }}
            </span>
          </span>

        </div>
      </li>
      <li class="filter-item">
        <label>时间范围</label>
        <div class="filter-item-content">
          <el-date-picker
            v-model="searchForm.dateRange"
            type="daterange"
            format="yyyy-MM-dd"
            class="filter-date"
            placeholder="开始日期~结束日期"
            @change="dateChange"
          />
        </div>
      </li>
      <li
        v-show="hasCondition"
        class="filter-item-condition"
      >
        <label class="history-area-active-text">已选条件</label>
        <div class="filter-item-content">
          <span
            v-for="(item, index) in searhTypeOptions"
            v-show="params[item.value] && params[item.value].length"
            :key="index"
            class="condition-item"
          >
            {{ item.label }}：
            <el-tag
              v-for="(word, index) in params[item.value]"
              :key="word"
              :closable="true"
              type="primary"
              @close="delOneWord(index, item.value)"
            >
              {{ word }}
            </el-tag>
          </span>

          <span
            v-show="params.attribute"
            class="condition-item"
          > 属性：
            <el-tag
              :closable="true"
              type="primary"
              @close="delAttribute"
            >
              {{ params.attribute }}
            </el-tag>
          </span>

        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { seedTagsService } from '../../../service/httpService'
import { mapState } from 'vuex'

export default {
  props: {
    query: {
      type: Object,
      default () {
        return {}
      }
    },
    needInputSearch: {
      type: Boolean,
      default () {
        return true
      }
    }
  },
  data () {
    return {
      searchForm: {
        searchType: 'titleAndMainContent',
        searchText: '',
        dateRange: [this.query.beginTime, this.query.endTime]
      },

      // 搜索参数
      params: {
        ...this.query
      },

      // 搜索类型
      searhTypeOptions: [
        ...window.dictionaryConfig.searhTypeOptions,
        {
          label: '数据来源',
          value: 'sources'
        },
        {
          label: '文章来源',
          value: 'sourceNames'
        }
      ],

      // 属性选择配置
      atributeOptions: []
    }
  },
  computed: {
    ...mapState({
      comeFromOldSystem: 'comeFromOldSystem'
    }),
    hasCondition () {
      for (let i in this.searhTypeOptions) {
        let type = this.searhTypeOptions[i].value
        if (this.params[type] && this.params[type].length) {
          return true
        }
      }

      if (this.params.attribute) {
        return true
      }

      return false
    }
  },
  mounted () {
    delete this.params.menuId
    this.getAttributeOptions()

    // 设置搜索类型

    if (this.comeFromOldSystem) {
      this.searhTypeOptions.splice(5, 1)
    } else {
      this.searhTypeOptions.splice(4, 1)
    }
  },
  methods: {
    getAttributeOptions () {
      seedTagsService.seedProperties().then(res => {
        this.atributeOptions = res.data
      })
    },

    // 输入框检索和删除某个搜索词@params:searchType @params:searchText
    search (data) {
      // 如果调用search方法并传参，则是接受子组件传入参数进行搜索
      let nowType = data.searchType || this.searchForm.searchType
      let text = data.searchText || this.searchForm.searchText

      // 搜索词变数组-分词检索
      text = text.replace(/\s*,\s*|\s*、\s*|\s*，\s*|\s*;\s*|\s*；\s*|\s*。\s*|\s+/g, ',')
      
      const wordArray = text.split(',')
      let array = this.params[nowType]

      wordArray.forEach(element => {
        if (!element.replace(/\s/g, '')) {
          this.$message({ type: 'info', message: '已过滤为空的搜索条件' })
          return false
        }

        // 这个搜索类型的判断
        if (array.indexOf(element) === -1) {
          array.push(element)        
        } else {
          this.$message.info('已过滤重复搜索条件')
        }
      })
      this.emitSearch()
    },
    delOneWord (index, wordType) {
      this.params[wordType].splice(index, 1)
      this.emitSearch()
    },

    // 属性的选择和删除
    choseAttribute (item) {
      this.params.attribute = item.Name
      this.emitSearch()
    },
    delAttribute () {
      this.params.attribute = ''
      this.emitSearch()
    },

    // 时间参数处理
    dateChange (value) {
      this.params.beginTime = this.searchForm.dateRange[0]
      this.params.endTime = this.searchForm.dateRange[1]
      this.emitSearch()
    },

    // 通知父组件执行搜索
    emitSearch () {
      this.$emit('search', this.params)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/history/history-area/search-header.vue